export default __webpack_public_path__ + "static/media/Floor-Plan-2D.cca17d6a.jpg";